import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

const values = [
  {
    icon: "ri-sparkling-2-line",
    title: "只推舒服版本",
    desc: "我们不看名气，只看实际阅读体验。逐话对比后，把真正舒服的润色版推荐给你。",
  },
  {
    icon: "ri-shield-check-line",
    title: "拒绝盗版导流",
    desc: "本网站仅做汉化质量评测与推荐，不提供任何盗版资源下载或在线链接，尊重原作者创作。",
  },
  {
    icon: "ri-eye-2-line",
    title: "删页差异说清",
    desc: "平台版删了什么、少看了什么，我们用截图对比一页页标出来，绝不模棱两可。",
  },
  {
    icon: "ri-message-3-line",
    title: "吐槽有理有据",
    desc: "嵌字、翻译、机翻的槽点，都有具体分镜和案例支撑，不是为吐槽而吐槽。",
  },
];

const principles = [
  "不夸大：评分与推荐都基于逐话对比的实际结果。",
  "不站队：不捧特定汉化组，只看某一版的实际质量。",
  "不误导：删页、改译等差异截图标注到具体章节。",
  "求客观：同一作品多版本并列，好坏由你判断。",
];

export default function About() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />

      <main className="mx-auto max-w-7xl px-4 md:px-6 pt-24 md:pt-32 pb-16">
        <nav aria-label="面包屑" className="text-sm text-foreground-500">
          <ol className="flex flex-wrap items-center gap-1">
            <li><Link to="/" className="hover:text-primary-600">首页</Link></li>
            <li><i className="ri-arrow-right-s-line" aria-hidden="true"></i></li>
            <li aria-current="page" className="text-foreground-800">关于我们</li>
          </ol>
        </nav>

        <header className="mt-6 max-w-3xl">
          <p className="font-label text-sm text-primary-600">ABOUT US</p>
          <h1 className="mt-2 font-heading text-3xl font-black text-foreground-950 md:text-5xl">关于炮渣漫画网</h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            「炮渣」是自嘲，也是态度——阅本无数、踩雷无数的我们，把走过的弯路、挖到的宝藏都记在这里。
            炮渣漫画网专注汉化质量评测，神翻译合集与润色版推荐、翻译对比看清删页差异、嵌字吐槽与质量差作品避雷，
            希望能帮你避开烂翻译烂嵌字，把时间花在真正舒服的版本上。
          </p>
        </header>

        {/* 定位 */}
        <section className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-2">
          <div className="rounded-xl bg-background-100 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-xl text-background-50">
              <i className="ri-crosshair-2-line" aria-hidden="true"></i>
            </span>
            <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">网站定位</h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">
              我们是一个汉化质量评测社区，不做资源站、不搞搬运。核心工作是逐话对比同一作品的不同版本，
              把翻译优劣、嵌字粗糙度、删页差异讲清楚，让读者能快速挑到读着舒服的版本。
            </p>
          </div>
          <div className="rounded-xl bg-background-100 p-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-xl text-background-50">
              <i className="ri-compass-3-line" aria-hidden="true"></i>
            </span>
            <h2 className="mt-4 font-heading text-lg font-bold text-foreground-950">我们想解决什么</h2>
            <p className="mt-2 text-sm leading-relaxed text-foreground-700">
              很多人都有过「读到一半才发现是机翻」「平台版删了关键分镜自己没察觉」的经历。
              炮渣把这些信息集中起来，让踩雷的成本降到最低，让好版本被更多人看到。
            </p>
          </div>
        </section>

        {/* 栏目价值 */}
        <section className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div key={v.title} className="rounded-xl bg-background-50 p-5 ring-1 ring-background-200 transition-shadow hover:shadow-lift">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-secondary-100 text-lg text-secondary-700">
                <i className={v.icon} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{v.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </section>

        {/* 内容原则 */}
        <section className="mt-10 rounded-xl bg-background-100 p-6 md:p-8">
          <h2 className="font-heading text-xl font-bold text-foreground-950">内容原则</h2>
          <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {principles.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm text-foreground-700">
                <i className="ri-check-double-line mt-0.5 text-accent-600" aria-hidden="true"></i>
                <span>{p}</span>
              </li>
            ))}
          </ul>
        </section>

        {/* 联系我们 */}
        <section className="mt-10 flex flex-col items-center justify-between gap-4 rounded-xl bg-primary-500 px-6 py-8 text-center sm:flex-row sm:text-left">
          <div>
            <h2 className="font-heading text-xl font-bold text-background-50">想投稿、吐槽或合作？</h2>
            <p className="mt-1 text-sm text-background-50/90">
              把踩雷经历、宝藏汉化或建议发给我们，经审核后会标注来源收录进对应栏目。
            </p>
          </div>
          <Link
            to="/contact"
            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-background-50 px-6 py-3 text-sm font-semibold whitespace-nowrap text-primary-600"
          >
            联系我们
            <i className="ri-send-plane-line" aria-hidden="true"></i>
          </Link>
        </section>
      </main>

      <Footer />
    </div>
  );
}